import React from "react";
import SimpleModal from "components/SimpleModal";
import JSONPretty from "react-json-pretty";

interface Props {
  // PropTypes: workflowParams?: PropTypes.object — passed straight to
  // JSONPretty's `data` (typed `any`); loosely typed as an object record.
  workflowParams?: Record<string, unknown>;
  // PropTypes: onClose?: PropTypes.func — invoked with no args.
  onClose?: () => void;
}

const WorkflowParamsModal = ({ workflowParams, onClose }: Props) => {
  return (
    <SimpleModal
      show={true}
      size={"xl"}
      onClose={() => onClose!()}
      title="Workflow Params"
      buttonText="close"
    >
      <JSONPretty
        data={workflowParams}
        themeClassName="custom-json-pretty"
        style={{ fontSize: "14px", margin: 15 }}
        mainStyle="background:#F7F7F7; line-height:1.3; padding: 20px; ;overflow:auto; color:#999;"
        keyStyle="color:#905;"
        stringStyle="color:#690;"
        valueStyle="color:#905;"
        booleanStyle="color:#905;"
      />
    </SimpleModal>
  );
};

export default WorkflowParamsModal;
